import $ from "jquery";
import "bootstrap";

require('./bootstrap');
require('./utilities');
require('../../shared/datepicker/auto');
require('./step1');
require('../../shared/lightgallery/lightgallery');

/* Image require to one page portfolio*/

require("../../images/hero.png");
require("../../images/hero.jpg");

require("../../images/logos/mavir_logo.png");
require("../../images/logos/MAVIRSE_logo.png");
require("../../images/logos/hupx.png");
require("../../images/logos/75.png");
require("../../images/logos/mavir_gray_logo.png");


require("../../images/officers/bodai_istvan.png");
require("../../images/officers/janosne_gabi.png");
require("../../images/officers/katalin_agnes.png");
require("../../images/officers/kopacsi_edina.png");
require("../../images/officers/lodi_edit.png");
require("../../images/officers/majer_milan.png");
require("../../images/officers/negelle_anna.png");
require("../../images/officers/orsolya_agota.png");
require("../../images/officers/polhy_katalin.png");
require("../../images/officers/tihanyi_zoltan.png");

require("../../images/szakosztalyok/fallabda.jpg");
require("../../images/szakosztalyok/fittness.jpg");
require("../../images/szakosztalyok/asztalitenisz.jpg");
require("../../images/szakosztalyok/foci.jpg");
require("../../images/szakosztalyok/futas.jpg");
require("../../images/szakosztalyok/horgasz.jpg");
require("../../images/szakosztalyok/kerekpar.jpg");
require("../../images/szakosztalyok/labdas.jpg");
require("../../images/szakosztalyok/sakk.jpg");
require("../../images/szakosztalyok/si.jpg");
require("../../images/szakosztalyok/szabadido.jpg");
require("../../images/szakosztalyok/teke.jpg");
require("../../images/szakosztalyok/termeszet.jpg");
require("../../images/szakosztalyok/vitorlas.jpg");
require("../../images/szakosztalyok/vizisport.jpg");
require("../../images/szakosztalyok/tenisz.jpg");


// require("../../images/custom-competitions/Hero.jpg");
require("../../images/custom-competitions/Rectangle 13.png");
require("../../images/custom-competitions/Rectangle 17.png");
require("../../images/custom-competitions/pdf_icon.png");
require("../../images/custom-competitions/full_size.png");

require('../../images/logos/favicon-32x32.png');
require('../../images/logos/favicon-16x16.png');

require('../../images/custom-competitions/flags/1.png');
require('../../images/custom-competitions/flags/2.png');
require('../../images/custom-competitions/flags/3.png');

/*$(function () {

    const $lightGallery = $("#lightgallery");
    if($lightGallery.length){
        //console.log("Lightgallery is here",lightGallery, typeof  lightGallery);
        $lightGallery.lightGallery();
    }

});*/



// Svg icon
require("../../images/calendar.svg");
